import { SignIn } from "@clerk/clerk-react";

export function SignInPage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full space-y-8">
				<div>
					<div className="flex justify-center">
						<div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
							<span className="text-white font-bold text-lg">CC</span>
						</div>
					</div>
					<h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
						Sign in to ccflare Dashboard
					</h2>
					<p className="mt-2 text-center text-sm text-gray-600">
						Access your API management dashboard
					</p>
				</div>
				<div className="flex justify-center">
					<SignIn
						appearance={{
							elements: {
								formButtonPrimary:
									"bg-orange-500 hover:bg-orange-600 text-sm normal-case",
							},
						}}
						signUpUrl="/auth/sign-up"
						forceRedirectUrl="/dashboard"
					/>
				</div>
				<div className="text-center">
					<p className="text-sm text-gray-600">
						Don't have an account?{" "}
						<a
							href="/auth/sign-up"
							className="text-orange-500 hover:text-orange-600 font-medium"
						>
							Sign up here
						</a>
					</p>
				</div>
			</div>
		</div>
	);
}